import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { administrateReasonsTypes } from "../../../../../constants/statuses";
import { ReasonsNomenclatureDataInterface } from "../../../../../redux/interfaces/admin.interface";

const administrareReasonsTableData = [
  { value: "all", label: "Toate" },
  ...administrateReasonsTypes,
];

export const operationsTypes = [
  { value: 1, label: "Livrare" },
  { value: 2, label: "Ridicare" },
];

const getReasonTypesLabel = (status: number) => {
  const getStatus = administrareReasonsTableData.find(
    (item) => item.value === status,
  );
  return getStatus ? getStatus.label : "";
};

export const nomMotiveTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Denumire",
    value: "denumire",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Tip",
    value: "type",
    minW: 125,
    withFilter: administrareReasonsTableData,
  },
  {
    label: "Vizibil destinatar",
    value: "viz_dest",
    minW: 125,
  },
  {
    label: "Vizibil expeditor",
    value: "viz_exp",
    minW: 125,
  },
  {
    label: "Motiv",
    value: "operatie",
    minW: 125,
    withFilter: operationsTypes,
  },
];

export const getNomMotiveTableData = (
  data: ReasonsNomenclatureDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_motiv,
      crudData: item,
      data: [
        {
          title: item.denumire,
        },
        {
          badges: [
            {
              badgeText: getReasonTypesLabel(item.type),
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.viz_dest ? "Vizibil" : "Invizibil",
              badgeColor: item.viz_dest ? "light-success" : "light-danger",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.viz_exp ? "Vizibil" : "Invizibil",
              badgeColor: item.viz_exp ? "light-success" : "light-danger",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.mes_afisat ?? "-",
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
